/*
 * @Author: panweikang
 * @Date: 2024-01-04 15:13:14
 * @LastEditTime: 2024-01-17 13:08:07
 * @Description:
 */
import './invitation.scss'

import bgPng from '../../static/invitation/bg.png'
import { Avatar, List, Space, Image, Button, Toast } from 'antd-mobile'
import { getInviteListApi, jsConfigApi } from '../../api/yearEndReportApi'
import { useEffect } from 'react'
import { useState } from 'react'
import wxConfig from '../../utils/wxConfig'

import MHead from '../../components/MHead/index'
import { useNavigate } from 'react-router-dom'

let Invitation = () => {
  // document.title = '邀请记录'
  document.title = '瑞莱博2023年物流地产年度报告'
  let userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}')
  let navigate = useNavigate()
  useEffect(() => {
    // wxConfig()
    init()
  }, [])

  let [list, setList] = useState([])
  let init = async () => {
    let res = await getInviteListApi({
      openId: userInfo.openId,
    })
    setList(res.data || [])
    console.log(res)
  }
  let [shareVisible, setShareVisible] = useState(false)

  let shareFn = async () => {
    navigate(`/rlb/YearEndReport/share`)
    // setShareVisible(true)
    // let res = await jsConfigApi({
    //   url: window.location.href.split('#')[0],
    //   // url: 'http://activity.ixuanzhi.com',
    // })
    // console.log('updateAppMessageShareData', res)
    // window.wx.config({
    //   // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //   ...res,
    //   jsApiList: ['updateAppMessageShareData'], // 必填，需要使用的JS接口列表
    // })
    // window.wx.ready(() => {
    //   window.wx.updateAppMessageShareData({
    //     title: '瑞莱博年度报告',
    //     desc: `帮我点一下`,
    //     link: `https://activity.ixuanzhi.com/rlb/YearEndReport/0?shareOpenId=${userInfo.openId}`,
    //     // link: `${window.location.origin}/rlb/YearEndReport/0?shareOpenId=${userInfo.openId}`,
    //     // imgUrl: userInfo.headImgUrl,
    //     success: () => {
    //       // 设置成功
    //       // Toast.show('分享成功')
    //       console.log('成功')
    //     },
    //     fail: () => {
    //       // 设置成功
    //       console.log('失败')
    //     },
    //   })
    // })
    // window.wx.error(function (res) {
    //   console.log(res)
    // })
  }

  return (
    <div className="invitation">
      <MHead />
      <Image src={bgPng} fit="cover" width="100%" />
      <div className="info">
        <Avatar style={{ '--size': '32px' }} src={userInfo.headImgUrl} alt="avatar" />
        <p>
          您已经成功邀请<span>{list.length}</span>人
        </p>
      </div>
      <div className="list">
        <div className="listInfo">邀请记录</div>
        {list && list.length ? (
          <>
            {list.map((item, index) => {
              return (
                <div className="listItem" key={index}>
                  <Avatar style={{ '--size': '32px' }} src={item.headImgUrl} alt="avatar" />
                  <p>{item.nickName}</p>
                  <div className="des">
                    <p>+ {item.armouryNumber}</p>
                    <p>{item.createTime}</p>
                  </div>
                </div>
              )
            })}
          </>
        ) : (
          <div className="noData">- 还未成功邀请好友 -</div>
        )}
      </div>
      <div className="btnWrap">
        <Button block className="btn" color="primary" size="large" onClick={shareFn}>
          立即邀请
        </Button>
      </div>
      {/* <MShare
        visible={shareVisible}
        onClose={() => {
          setShareVisible(false)
        }}
      /> */}
    </div>
  )
}

export default Invitation
